setUserContactData